import React, { useEffect, useMemo, useRef, useState } from 'react'
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import Select from 'react-select';
import { FormControl, MenuItem, Stack, Typography } from '@mui/material';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkSpecialChar, checkString } from '../utilities/FormValidation';
import * as Flags from 'country-flag-icons/react/3x2';
import customStyles from 'app/shared-components/SelectCustomStyle';

const CityForm = () => {

    const countryURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;
    const cityURL = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.cities}`;
    const [tabValue, setTabValue] = useState(0);
    const { id } = useParams()
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [isNavigate, setIsNavigate] = useState(false);
    const [countryName, setCountryName] = useState("");
    const [cityName, setCityName] = useState("");
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [countryOptions, setCountryOptions] = useState();
    const [countryLink, setCountryLink] = useState("")
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [editData, setEditData] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)

    const handleSubmit = async () => {
        setCheckSubmit(true);

        let model = {
            cityName: cityName,
            country: countryLink
            // country: countryName
        };

        try {
            if (id) {
                if (cityName && !validError.cityName && countryName) {
                    cityURL += `/${id}`
                    await OAuthService.putData(cityURL, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/cities'); }, 800)
                }
            } else {
                if (cityName && !validError.cityName && countryName) {
                    await OAuthService.addData(cityURL, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/cities'); }, 800)
                }
            }

        } catch (error) {
            setError(error.message)
            return;
        }
    }

    const editCityData = async () => {
        try {
            if (id) {
                const result = await OAuthService.getEditData(cityURL, id);
                const city = result?.data?.cityName;
                const cityData = result?.data
                setCityName(city);
                const url = `${cityURL}/${id}/country`;
                const data = await OAuthService.getList(url);
                const country = data?.data?.name;
                const url1 = process.env.REACT_APP_RESOURCE_API_KEY_URL
                const url2 = result.data._links.country.href.split("/api")[1]
                setCountryLink(`${url1}api${url2}`)
                setCountryName(country);
                cityData.countryName = country;
                setEditData(cityData);
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (id) {
            editCityData();
            setHideDelete(false)
        }

    }, [])

    const handleDelete = async () => {

        try {
            if (id) {
                await OAuthService.deleteData(cityURL, id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                setTimeout(() => { navigate('/cities') }, 800);
            }

        } catch (error) {
            console.log("error", error);
            setError(error.message);
        }
    }

    const handleAddCountryChange = (data) => {
        setCountryName(data.value);
        setCountryLink(data._link);
    };

    useEffect(() => {
        const country = async () => {
            const countries = await OAuthService.getList(countryURL + '?size=1000');
            const result = countries?.data?._embedded.countries.map((value) => {
                const Flag = Flags[value?.isoCode];
                let _link = value._links.country.href
                return { label: value?.name, _link: _link, value: value?.name, code: value?.isoCode, icon: value?.isoCode && <Flag width={18} style={{ marginInline: "5px" }} /> }
            })
            setCountryOptions(result);
        }
        country();

    }, [])


    isNavigate ? navigate("/cities") : ""

    const handleCancel = () => {
        navigate("/cities")
    }

    useEffect(() => {
        if (countryName && cityName) {
            if (editData) {
                console.log(editData);
                if (countryName !== editData.countryName || cityName !== editData.cityName) {
                    setSaveDisable(false);
                } else {
                    setSaveDisable(true);
                }
            } else {
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    }, [countryName, cityName]);

    return (
        <div className='w-full overflow-scroll'>
            <FormPageHeader
                componentName="City"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                successMsg={successMsg}
                snackState={snackState}
                currentPage={id ? "Update City" : "Add City"}
                parentBreadcrumbData={[{ pageName: 'City List', pageLink: '/cities' }]}
                error={error}
                handleCancel={handleCancel}
                hideDelete={hideDelete}
                saveDisable={saveDisable}
            >

                <Tabs
          value={tabValue}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: 'w-full h-64 border-b-1' }}
        >
          <Tab 
            className="h-64" 
            label="Basic Info" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
        </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">

                <FormControl fullWidth>
                    <Stack>
                        <label>*Country Name</label>
                        <Stack className="mb-16">
                            <Select name="countryName"
                                value={(countryOptions && countryName) && countryOptions.filter(obj => countryName.includes(obj.value))}
                                onChange={handleAddCountryChange}
                                className="select"
                                classNamePrefix="select"
                                options={countryOptions}
                                isDisabled={id ? true : false}
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                                styles={customStyles(((checksubmit && !countryName) || validError.countryName) && "#f44336", ((id) && "gray"))}
                            />
                            <Typography mt={0.5} className="text-[#f44336] text-sm ml-14">{(checksubmit && !countryName) ? "This field is required" : validError.countryName}</Typography>
                        </Stack>
                    </Stack>
                </FormControl>
                <Stack>
                    <label>*City Name</label>
                    <TextField
                        className="mb-4"
                        type="text"
                        name="cityName"
                        value={cityName}
                        required
                        // error={(checksubmit && !cityName) || validError.cityName ? true : false}
                        onChange={(e) => { setCityName(e.target.value.toUpperCase()); setValidError({ ...validError, cityName: checkString(e.target.value) || checkSpecialChar(e.target.value) }) }}
                        // helperText={(checksubmit && !cityName) ? "This field is required" : validError.cityName}
                        variant="outlined"
                    />
                    <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !cityName) ? "This field is required" : validError.cityName}</Typography>
                </Stack>
            </div>
        </div >
    )
}

export default CityForm;